import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Flex, Grid, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	gridStyles: {
		height: '100%',
	},
	flexStyles: {
		textAlign: 'center',
		maxWidth: '440px',
		paddingInline: token('space.200'),
	},
	action: {
		marginTop: token('space.200'),
	},
});

export type ErrorLayoutProps = {
	action?: ReactNode;
	heading: ReactNode;
	illustration?: ReactNode;
	message: ReactNode;
	testId?: string;
};

export const ErrorLayout = ({
	heading,
	message,
	action,
	illustration,
	testId,
}: ErrorLayoutProps): React.JSX.Element => {
	return (
		<Grid justifyContent="center" xcss={styles.gridStyles} testId={testId}>
			<Flex
				direction="column"
				justifyContent="center"
				alignItems="center"
				xcss={styles.flexStyles}
				gap="space.200"
			>
				{illustration && (
					<Box testId={testId ? `${testId}__illustration` : undefined}>{illustration}</Box>
				)}
				<Heading size="large" testId={testId ? `${testId}__heading` : undefined}>
					{heading}
				</Heading>
				<Text color="color.text.subtle" testId={testId ? `${testId}__message` : undefined}>
					{message}
				</Text>
				{action && (
					<Box xcss={styles.action} testId={testId ? `${testId}__action` : undefined}>
						{action}
					</Box>
				)}
			</Flex>
		</Grid>
	);
};
